/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Syntax_Errors_CardInputs */

const en_guide_json_syntax_errors_card = /** @type {(inputs: Guide_Json_Syntax_Errors_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fix the most common JSON errors: trailing commas, single quotes, comments, and more.`)
};

const ko_guide_json_syntax_errors_card = /** @type {(inputs: Guide_Json_Syntax_Errors_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`가장 흔한 JSON 오류를 수정하세요: 후행 쉼표, 작은따옴표, 주석 등.`)
};

const ja_guide_json_syntax_errors_card = /** @type {(inputs: Guide_Json_Syntax_Errors_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最もよくあるJSONエラーを修正：末尾のカンマ、シングルクォート、コメントなど。`)
};

/**
* | output |
* | --- |
* | "Fix the most common JSON errors: trailing commas, single quotes, comments, and more." |
*
* @param {Guide_Json_Syntax_Errors_CardInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_syntax_errors_card = /** @type {((inputs?: Guide_Json_Syntax_Errors_CardInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Syntax_Errors_CardInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_syntax_errors_card(inputs)
	if (locale === "ko") return ko_guide_json_syntax_errors_card(inputs)
	return ja_guide_json_syntax_errors_card(inputs)
});